import React from "react";
import { FeatherAlertCircle } from "@subframe/core";

export interface ClosedMonthBannerProps {
  /** Optional entity label (e.g. "Invoice", "Bill", "Journal") for context. */
  entityLabel?: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Banner shown on view/edit screens when the document belongs to a closed month.
 * Informs the user that changes require review and approval.
 */
export const ClosedMonthBanner: React.FC<ClosedMonthBannerProps> = ({
  entityLabel,
  className = "",
}) => {
  const message = entityLabel
    ? `This ${entityLabel} is in a closed month. Any changes require review and approval.`
    : "This document is in a closed month. Any changes require review and approval.";

  return (
    <div
      className={`flex w-full flex-col items-start gap-3 rounded-md border border-solid border-neutral-200 bg-neutral-50 px-4 py-4 ${className}`}
      role="status"
    >
      <div className="flex w-full items-center gap-2">
        <FeatherAlertCircle className="h-5 w-5 text-neutral-600 flex-none" />
        <span className="text-body-bold font-body-bold text-neutral-700">
          Closed month
        </span>
      </div>
      <div className="flex flex-col items-start gap-1 pl-7">
        <span className="text-body font-body text-neutral-700">{message}</span>
      </div>
    </div>
  );
};
